const INCIDENT_TABS = {
  REGULAR: 'regular',
  FLAGGED: 'flagged',
};

export default INCIDENT_TABS;
